export default __webpack_public_path__ + "static/media/login-bg.4da7756d.png";